import ReportPage2 from "./report-page2";
export default ReportPage2;
